/**
 * Partner API
 *
 * Functions for managing the Partner Master (partners, subdivisions, addresses, aliases).
 */

import api from './index';

// ── Core CRUD ──────────────────────────────────────────────────────

export const getPartners = (params = {}) =>
  api.get('/partners', { params });

export const getPartner = (id) =>
  api.get(`/partners/${id}`);

export const createPartner = (data) =>
  api.post('/partners', data);

export const updatePartner = (id, data) =>
  api.patch(`/partners/${id}`, data);

export const deletePartner = (id) =>
  api.delete(`/partners/${id}`);

// ── Parent aliases ─────────────────────────────────────────────────

export const addPartnerAlias = (id, alias) =>
  api.patch(`/partners/${id}/aliases`, { alias });

export const removePartnerAlias = (id, alias) =>
  api.delete(`/partners/${id}/aliases`, { data: { alias } });

// ── Parent addresses ───────────────────────────────────────────────

export const addPartnerAddress = (id, address) =>
  api.post(`/partners/${id}/addresses`, address);

export const updatePartnerAddress = (id, addrId, data) =>
  api.patch(`/partners/${id}/addresses/${addrId}`, data);

export const removePartnerAddress = (id, addrId) =>
  api.delete(`/partners/${id}/addresses/${addrId}`);

// ── Subdivisions ───────────────────────────────────────────────────

export const addSubdivision = (id, data) =>
  api.post(`/partners/${id}/subdivisions`, data);

export const updateSubdivision = (id, subId, data) =>
  api.patch(`/partners/${id}/subdivisions/${subId}`, data);

export const removeSubdivision = (id, subId) =>
  api.delete(`/partners/${id}/subdivisions/${subId}`);

// ── Subdivision aliases ────────────────────────────────────────────

export const addSubdivisionAlias = (id, subId, alias) =>
  api.patch(`/partners/${id}/subdivisions/${subId}/aliases`, { alias });

export const removeSubdivisionAlias = (id, subId, alias) =>
  api.delete(`/partners/${id}/subdivisions/${subId}/aliases`, { data: { alias } });

// ── Subdivision addresses ──────────────────────────────────────────

export const addSubdivisionAddress = (id, subId, address) =>
  api.post(`/partners/${id}/subdivisions/${subId}/addresses`, address);

export const updateSubdivisionAddress = (id, subId, addrId, data) =>
  api.patch(`/partners/${id}/subdivisions/${subId}/addresses/${addrId}`, data);

export const removeSubdivisionAddress = (id, subId, addrId) =>
  api.delete(`/partners/${id}/subdivisions/${subId}/addresses/${addrId}`);

// ── Adoption ───────────────────────────────────────────────────────

export const adoptPartner = (parentId, childId) =>
  api.post(`/partners/${parentId}/adopt/${childId}`);

// ── Status (convenience) ───────────────────────────────────────────

export const updatePartnerStatus = (id, status) =>
  api.patch(`/partners/${id}`, { status });

// ── Bulk Operations ─────────────────────────────────────────────────

export const downloadBulkTemplate = async (format = 'xlsx') => {
  if (format === 'json') {
    return api.get('/partners/bulk/template', { params: { format: 'json' } });
  }
  return api.get('/partners/bulk/template', {
    params: { format: 'xlsx' },
    responseType: 'blob',
  });
};

export const exportPartners = async (format = 'xlsx') => {
  if (format === 'json') {
    return api.get('/partners/bulk/export', { params: { format: 'json' } });
  }
  return api.get('/partners/bulk/export', {
    params: { format: 'xlsx' },
    responseType: 'blob',
  });
};

export const importPartners = async (file, dryRun = false) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post(`/partners/bulk?dryRun=${dryRun}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
